import FullScreenDrawerView from './FullScreenDrawerView';

import { IDrawer } from './interfaces';

const FullScreenDrawer = ({ isOpen, onClick }: IDrawer) => {
  return <FullScreenDrawerView isOpen={isOpen} onClick={onClick} />;
};

export default FullScreenDrawer;
